import { render, staticRenderFns } from "./CategroyEditForm.vue?vue&type=template&id=701512cf&scoped=true"
import script from "./CategroyEditForm.vue?vue&type=script&lang=js"
export * from "./CategroyEditForm.vue?vue&type=script&lang=js"
import style0 from "./CategroyEditForm.vue?vue&type=style&index=0&id=701512cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "701512cf",
  null
  
)

export default component.exports